<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:body>
            <p v-show="!propOpenedInModal">{{cvCardSubHeader}}</p>
            <form action="#" v-if="vmgpath_companyFormData && Object.keys(vmgpath_companyFormData).length > 0">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationpdt_id">{{cvPdtIdLabel}}</label>
                  <input
                    v-model="vmgpath_companyFormData.pdt_id"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationname">{{cvNameLabel}}</label>
                  <input
                    v-model="vmgpath_companyFormData.name"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationcareer_key">{{cvCareerKeyLabel}}</label>
                  <input
                    v-model="vmgpath_companyFormData.career_key"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationcompany_name">{{cvCompanyNameLabel}}</label>
                  <input
                    v-model="vmgpath_companyFormData.company_name"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationcompany_logo">{{cvCompanyLogoLabel}}</label>
                  <input
                    v-model="vmgpath_companyFormData.company_logo"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="gpcpEdit()">{{cvSubmitBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { gpathCompanys } from "../../../FackApi/api/GpathCompany"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "gpathCompanyEdit",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propgpath_companyObj: {
      type: Object,
      default: function () {
        return {
          "pdt_id": "",
          "name": "",
          "career_key": "",
          "company_name": "",
          "company_logo": ""
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Edit gpcp",
      cvCardSubHeader: "Edit gpcp sub header",
      cvSubmitBtn: "Edit",
      cvPdtIdLabel: "pdt id",
      cvNameLabel: "name",
      cvCareerKeyLabel: "career key",
      cvCompanyNameLabel: "company name",
      cvCompanyLogoLabel: "company logo",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "gpath_company Updated",
      vmgpath_companyFormData: {}
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    socialvue.index()
    this.gpcpView()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmgpath_companyFormData) {
          if (!this.vmgpath_companyFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * gpcpView
     */
    async gpcpView () {
      try {
        if (this.propOpenedInModal) {
          this.vmgpath_companyFormData = this.propgpath_companyObj
        }
        else {
          let gpcpId = this.$route.params.gpcp_id
          let gpcpViewResp = await gpathCompanys.gpcpView(this, gpcpId)

          if (gpcpViewResp && gpcpViewResp.resp_status) {
            this.vmgpath_companyFormData = gpcpViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcpView() and Exception:", err.message)
      }
    },
    /**
     * gpcpEdit
     */
    async gpcpEdit () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true
        let gpcpAddResp = await gpathCompanys.gpcpEdit(this, this.vmgpath_companyFormData)
        await ApiResponse.responseMessageDisplay(this, gpcpAddResp)

        if (gpcpAddResp && !gpcpAddResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitClosegpathCompanyEditModal", this.vmgpath_companyFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcpEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
